import React from 'react';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CircularProgress from '@mui/material/CircularProgress';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

interface LoadingDisplayProps {
  message?: string;
}

const LoadingDisplay: React.FC<LoadingDisplayProps> = (props) => {
  let { message = 'Loading...' } = props;

  return (
    <Card elevation={3} sx={{ p: 3, borderRadius: 2, width: '100%' }}>
      <Box
        sx={{
          position: 'relative',
          height: 100,
        }}
      >
        <Skeleton variant="rectangular" animation="wave" height="100%" sx={{ borderRadius: 2 }} />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
          <Typography style={{ marginLeft: 25 }}>{message}</Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default LoadingDisplay;
